import {Component, Input, OnInit} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {merge} from "rxjs";
import {MessagesService} from "../../services/messages/messages.service";
import {ArtworkService} from "../../services/artwork/artwork.service";
import {Router} from "@angular/router";
import {Route} from "../../models/route";
import {RouteService} from "../../services/route/route.service";
import {RouteModal} from "../../modals/route-modal/route-modal.component";

@Component({
  selector: 'app-routes',
  templateUrl: './routes.component.html',
  styleUrls: ['./routes.component.scss']
})
export class RoutesComponent implements OnInit {

  @Input() projectId: string;
  @Input() databaseId: string;
  @Input() code: string;

  routes: Array<Route> = [];

  constructor(
    private modalService: NgbModal,
    private artworkService: ArtworkService,
    private routeService: RouteService,
    private messagesService: MessagesService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    merge(
      this.routeService.getAllMyRoutes(this.projectId, this.databaseId),
      this.routeService.onChange
    ).subscribe(
      () => this.routes = this.routeService.routes,
      err => this.messagesService.errorToast(err));
  }

  onShowModal() {
    const modalRef = this.modalService.open(RouteModal, {size: 'lg'});
    modalRef.componentInstance.projectId = this.projectId;
    modalRef.componentInstance.databaseId = this.databaseId;
    modalRef.componentInstance.routesLength = this.routes.length;
  }

  onDelete(routeId) {
    this.messagesService.confirmModal().result
      .then(
        result => {
          if (result) {
            this.routeService.deleteRoute(this.projectId, this.databaseId, routeId)
              .subscribe(
                () => {
                  this.messagesService.successToast('Route deleted.');
                  this.router.navigateByUrl('projects/' + this.projectId + '/databases/' + this.databaseId);
                },
                err => this.messagesService.errorToast(err)
              );
          }
        })
      .catch(() => {
      });
  }
}
